import { Button, Heading, Image, Text, VStack } from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'
import WelcomeImage from 'assets/Images/Welcome.png'

type Inviter = {
  workspace?: string
  organization?: string
}

export type WelcomeProps = {
  inviter?: Inviter
  onNext: () => void
}

const Welcome = ({ onNext, inviter }: WelcomeProps) => {
  const { formatMessage } = useContent()

  return (
    <CardPage maxW="784px" trackingName="Welcome">
      <VStack textColor="grayscale.primary" spacing={6}>
        <Image src={WelcomeImage} width="auto" height="auto" />
        <VStack mb={6} spacing={0} textAlign="center">
          <Heading fontSize="3xl">
            {formatMessage({ id: 'pmportal.onboarding.welcome.header' })}
          </Heading>
          <Text fontSize="large">
            {formatMessage({ id: 'pmportal.onboarding.welcome.subheader' })}
          </Text>
        </VStack>

        <VStack mb={6} spacing={0} textAlign="center">
          {inviter && inviter.workspace && inviter.organization && (
            <Text fontSize="small" lineHeight="small">
              {formatMessage(
                { id: 'pmportal.onboarding.welcome.invite' },
                {
                  organization: inviter?.organization,
                  workspace: inviter?.workspace,
                }
              )}
            </Text>
          )}
          <Text fontSize="small" lineHeight="small">
            {formatMessage({ id: 'pmportal.onboarding.welcome.getStarted' })}
          </Text>
        </VStack>

        <Button onClick={onNext} alignSelf="center">
          {formatMessage({ id: 'pmportal.onboarding.welcome.registerButton' })}
        </Button>
      </VStack>
    </CardPage>
  )
}

export default Welcome
